import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';

class ApplicationsIssuesController implements angular.IComponentController {
    isLoading: boolean;
    static $inject = [];
}

export const wtApplicationsIssues: ComponentDefinition = {
    componentId: 'wtApplicationsIssues',
    controller: ApplicationsIssuesController,
    template: require('./applicationsIssues.component.html'),
    controllerAs: 'vm'
};
